export default __webpack_public_path__ + "static/media/TUSD-BUSD.f52a19f8.svg";